import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import swissmap_de from './locales/de/swissmap-de.json'
import swissmap_fr from './locales/fr/swissmap-fr.json'

i18n.use(initReactI18next).init({
  resources: {
    de: {
      swissmap: swissmap_de,
    },
    fr: {
      swissmap: swissmap_fr,
    },
  },
  fallbackLng: 'de',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
